import { BaseService } from './BaseService'
const SIGNUP_PATH = '/users/register'
const LOGIN_PATH = '/login'
const UPDATE_PASSWORD_PATH = '/users/update-password'
const FORGOT_PASSWORD_PATH = '/users/new-password/token'
const RESET_PASSWORD_PATH = '/users/reset-password'
const REFRESH_TOKEN_PATH = '/token/refresh'
const ACTIVATE_USER_PATH = '/users/approve-account'
const RESEND_ACTIVATION_PATH = '/users/resend-activation'
const VERIFY_2FA_PATH = '/2fa/verify'
const COMPLETE_SOCIAL_REGISTRATION_PATH = '/users/complete-social-registration'
/* eslint-disable */ 
class AuthService extends BaseService {
  signUp (formData) {
    return this.post(SIGNUP_PATH, formData)
  }
  login (formData) {
    return this.post(LOGIN_PATH, formData)
  }
  logout () {
    return this.post('/logout', {})
  }
  renewToken () {
    // Backend refresh subscriber reads the latest refresh token from HttpOnly cookie.
    // Avoid sending a potentially stale local token when single_use rotation is enabled.
    return this.post(REFRESH_TOKEN_PATH, {})
  }
  updatePassword (formData) {
    return this.put(UPDATE_PASSWORD_PATH, formData)
  }
  forgotPassword (formData) {
    return this.post(FORGOT_PASSWORD_PATH, formData)
  }
  resetPassword (formData) {
    return this.put(RESET_PASSWORD_PATH, formData)
  }
  activateUser (formData) {
    return this.post(ACTIVATE_USER_PATH, formData)
  }
  resendActivation (formData) {
    return this.post(RESEND_ACTIVATION_PATH, formData)
  }
  verify2fa (formData) {
    return this.post(VERIFY_2FA_PATH, formData)
  }
  completeSocialRegistration (formData) {
    return this.post(COMPLETE_SOCIAL_REGISTRATION_PATH, formData)
  }
}
export default new AuthService()
/* eslint-disable */ 
